import styled from 'styled-components';

import { BREAK_POINTS } from '../../consts/styleDedupe';

export const ProductCardsContainer = styled.div`
  @media screen and (max-width: ${BREAK_POINTS.Max.MD}) {
    & > *:not(:last-child) {
      margin-bottom: 32px;
    }
  }
  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    display: flex;
    flex-wrap: wrap;
    & > * {
      width: calc(50% - 1 / 2 * 24px);
    }
    & > *:nth-child(2n) {
      margin-left: 24px;
    }
    & > *:nth-last-child(n + 3) {
      margin-bottom: 32px;
    }
  }
`;
